<div class="container">
    @if(isSubmitting) {
    <div class="signing-overlay">
        <div class="spinner-ring"></div>
    </div>
    }
    <ng-template #pdfViewerTemplate>
        <div class="pdf-viewer">
            @if (viewURL) {
            <object [data]="viewURL | sanitizerUrl" type="application/pdf" width="100%" height="100%"></object>
            } @else {
            <div class="empty-state">
                @if (isSelectedFileLoading()) {
                <i class="pi pi-spin pi-spinner"></i>
                } @else {
                <i class="pi pi-file-pdf"></i>
                }
            </div>
            }
        </div>
    </ng-template>

    <ng-template #signaturePadTemplate>
        @if (!isOwner){

        <div class="signature-view">
            @if(showSignaturePad){
            <div class="signature-pad-wrapper">
                <ngx-signature-pad #signaturePad class="signaturePad" [options]="options" (onEnd)="onSignatureChange()">
                </ngx-signature-pad>
            </div>
            }
            <ng-container *ngTemplateOutlet="signatureActionsTemplate"></ng-container>
        </div>
        }
    </ng-template>

    <ng-template #signatureActionsTemplate>
        <div class="signature-actions">
            <div class="comment-field">
                <label class="comment-label" for="signature-comment">
                    <span class="material-symbols-outlined">chat_bubble</span>
                    {{ "Comment" | translate }}
                </label>
                <textarea id="signature-comment" class="signature-comment" [(ngModel)]="comment" maxlength="500"
                    placeholder="{{ 'Add a comment (optional)' | translate }}"></textarea>
            </div>
            <div class="top-buttons">
                <button class="signature-btn reject-btn" [disabled]="!areButtonsEnabled()" (click)="accept(false)">
                    <span class="material-symbols-outlined">close</span>
                    {{ "Reject" | translate }}
                </button>
                @if (showSignaturePad){
                <button class="signature-btn clear-btn" [disabled]="isEmpty()" (click)="clear()">
                    <span class="material-symbols-outlined">refresh</span>
                    {{ "Clear" | translate }}
                </button>
                }
            </div>
            <button class="signature-btn accept-btn" [disabled]="!isSignEnabled()" (click)="accept(true)">
                <span class="material-symbols-outlined">signature</span>
                {{ "Sign" | translate }}
            </button>
        </div>
    </ng-template>

    <ng-template #alreadySignedTemplate>
        @if (!isOwner){
        <div class="already-signed" [ngClass]="{'status-rejected': userStatus === 'REJECTED'}">
            <div class="signed-icon">
                @if(userStatus === 'REJECTED') {
                <i class="pi pi-times-circle"></i>
                } @else {
                <i class="pi pi-check-circle"></i>
                }
            </div>
            @if(userStatus === 'REJECTED') {
            <h4>{{ "You have rejected this document" | translate }}</h4>
            } @else {
            <h4>{{ "You have already signed" | translate }}</h4>
            }
            @if(userSignatureDate && !userSignatureBase64) {
            <p class="signed-date">
                <mat-icon>schedule</mat-icon>
                <span>{{ userSignatureDate | date: short24 }}</span>
            </p>
            }
            @if(userSignatureBase64 && userStatus === 'SIGNED') {
            <div class="user-signature-preview">
                <div class="signature-container">
                    <img [src]="userSignatureBase64" alt="Your Signature" class="signature-image">
                </div>
            </div>
            }
            @if(userComment) {
            <p class="signed-comment">
                <strong>{{ "Comment" | translate }}:</strong>
                <span>{{ userComment }}</span>
            </p>
            }
        </div>
        }
    </ng-template>

    <ng-template #viewMessageTemplate>
        @if (!isOwner){
        <div class="view-message">
            <span class="material-icons">error</span>
            {{ "You must view all documents before performing any action." | translate }}
        </div>
        }
    </ng-template>

    <ng-template #shareInfoTemplate>
        <div class="share-info">
            @if (status != null) {
            <div class="status-row">

                <div class="access-status" [ngClass]="{
                    'status-pending': status === 'PENDING' || status === 'VIEWED',
                    'status-signed': status === 'SIGNED' || status === 'COMPLETED', 
                    'status-rejected': status === 'REJECTED' || status === 'EXPIRED'
                }">
                    <span class="status-badge">{{ status | translate }}</span>
                </div>

            </div>
            }
            <div><strong>{{"Shared by" | translate}}:</strong> {{ sharedBy }}</div>
            <div><strong>{{"Subject" | translate}}:</strong> {{ subject }}</div>
            @if (enabled){
            <div class="expiration"><strong>{{"Expires on" | translate}}:</strong> {{ expirationDate | date:short24 }}
            </div>
            }
            @else{
            <div class="expiration"><strong>{{"Expired on" | translate}}</strong> : {{ expirationDate | date:short24 }}
            </div>
            }

        </div>
    </ng-template>

    <ng-template #footerTemplate>
        <div class="footer">
            @if (domainInfo) {
            <div class="info">
                <span class="name" [pTooltip]="domainInfo.companyName" tooltipPosition="top">{{ domainInfo.companyName
                    }}</span>
                <span class="location">{{ domainInfo.address }}</span>
                <span class="vat">{{ domainInfo.fiscalInfo }}</span>
            </div>
            }
            <div class="plenion">
                <span>{{ "Powered by" | translate }}:</span>
                <img src="favicon.ico" alt="Plenion Logo" class="plenion-logo">
                <span class="bold">Plenion</span>
            </div>
        </div>

    </ng-template>

    <ng-template #accessesListTemplate>
        <div class="accesses-content">
            <div class="accesses-list">
                @for (access of accesses; track access.id) {
                <div class="access-item">
                    <div class="access-content-wrapper">
                        <div class="access-info">
                            <div class="access-id">
                                <span class="material-symbols-outlined">
                                    {{ access.userType === 'email' ? 'email' : 'person' }}
                                </span>
                                <span class="access-name">
                                    {{ access.userType === 'email' ? access.id : access.userName }}
                                </span>
                            </div>
                            <div class="access-details">
                                @if(access.date && !access.signatureBase64) {
                                <span class="access-date">
                                    <mat-icon class="date-icon">schedule</mat-icon>
                                    @if(access.status === 'PENDING' || access.status === 'VIEWED') {
                                    <strong>{{"Last Visit" | translate}}:</strong>
                                    } @else if(access.status === 'SIGNED') {
                                    <strong>{{"Signing Date" | translate}}:</strong>
                                    } @else if(access.status === 'REJECTED') {
                                    <strong>{{"Reject Date" | translate}}:</strong>
                                    }
                                    {{ (access.date) | date:short24 }}
                                </span>
                                }
                                @if(access.ip && !access.signatureBase64) {
                                <span class="access-date">
                                    <i class="pi pi-globe date-icon"></i>
                                    <strong>IP:</strong>
                                    {{ access.ip }}
                                </span>
                                }
                                @if(access.status === 'SIGNED' && access.signatureBase64) {
                                <div class="signature-preview">
                                    <strong>{{"Signature" | translate}}:</strong>
                                    <img [src]="access.signatureBase64" alt="Signature" class="signature-image">
                                </div>
                                }
                                @if(access.comment) {
                                <div class="access-comment">
                                    <span class="material-symbols-outlined comment-icon">format_quote</span>
                                    <p>{{ access.comment }}</p>
                                </div>
                                }
                            </div>
                        </div>
                        @if ( status != null) {
                        <div class="access-status-wrapper">
                            <div class="access-status" [ngClass]="{
                            'status-pending': access.status === 'PENDING' || access.status === 'VIEWED',
                            'status-signed': access.status === 'SIGNED',
                            'status-rejected': access.status === 'REJECTED'
                        }">
                                <span class="status-badge">{{ access.status | translate}}</span>
                            </div>
                            @if (isOwner && canDeleteUser(access)) {
                            <button class="delete-icon" (click)="deleteElement(access, 'access')"
                                [pTooltip]="'Remove Access' | translate" tooltipPosition="top">
                                <i class="pi pi-trash"></i>
                            </button>
                            }
                        </div>
                        }
                    </div>
                </div>
                }
                @if(accesses.length === 0) {
                <div class="empty-accesses">
                    <i class="pi pi-users"></i>
                    <p>{{ "No accesses found" | translate }}</p>
                </div>
                }
            </div>
        </div>
    </ng-template>

    <ng-template #tabsTemplate let-isMobile="isMobile">
        @if (isOwner) {
        <div [class]="isMobile ? 'mobile-tabs' : 'custom-tabs'">
            <button [class]="isMobile ? 'tab-btn' : 'custom-tab'" [class.active]="activeTab === 'signing'"
                (click)="scrollToTop()">
                <span class="material-symbols-outlined">signature</span>
                {{ "Overview" | translate }}
            </button>
            <button [class]="isMobile ? 'tab-btn' : 'custom-tab'" [class.active]="activeTab === 'accesses'"
                (click)="activeTab = 'accesses'">
                <span class="material-icons-outlined">people</span>
                {{ "Accesses" | translate }}
            </button>
        </div>
        }
    </ng-template>


    @if(device === 'mobile' && activeTab === 'signing') {
    <div class="mobile-header">
        <button class="nav-btn" [disabled]="(currentFileIndex === 0 && (isOwner || type !== 'Sign')) || (type === 'Sign' && !isOwner && ((userSigned && showSignatureView) || (!userSigned && currentFileIndex === 0 && !showSignatureView)))" (click)="previousFile()">
            <span class="material-symbols-outlined">arrow_back</span>
            {{ "Previous" | translate }}
        </button>
        <div class="file-info">
            @if(showSignatureView && type === 'Sign' && !isOwner) {
            @if(userSigned) {
            <span class="file-name">{{ "Signed" | translate }}</span>
            } @else {
            <span class="file-name">{{ "Signature" | translate }}</span>
            }
            } @else {
            <span class="file-name" [pTooltip]="$safeNavigationMigration(files[currentFileIndex]?.name)" tooltipPosition="top">{{
                files[currentFileIndex]?.name }}</span>
            <small class="file-counter">{{ currentFileIndex + 1 }}/{{ files.length }}</small>
            }
        </div>
        @if(userSigned && type === 'Sign' && !isOwner) {
            @if(showSignatureView) {
            <button class="nav-btn" (click)="nextFile()">
                {{ "Next" | translate }}
                <span class="material-symbols-outlined">arrow_forward</span>
            </button>
            } @else if(currentFileIndex < files.length - 1) {
            <button class="nav-btn" (click)="nextFile()">
                {{ "Next" | translate }}
                <span class="material-symbols-outlined">arrow_forward</span>
            </button>
            } @else {
            <button class="nav-btn" disabled>
                {{ "Next" | translate }}
                <span class="material-symbols-outlined">arrow_forward</span>
            </button>
            }
        } @else if(currentFileIndex < files.length - 1) {
            <button class="nav-btn" (click)="nextFile()">
                {{ "Next" | translate }}
                <span class="material-symbols-outlined">arrow_forward</span>
            </button>
        } @else if(type === 'Sign' && !isOwner) {
            <button class="nav-btn signature-nav" [disabled]="showSignatureView" (click)="scrollToSignature()">
                @if (!showSignatureView) {
                {{ "Signature" | translate }}
                <span class="material-symbols-outlined">signature</span>
                } @else {
                {{ "Next" | translate }}
                <span class="material-symbols-outlined">arrow_forward</span>
                }
            </button>
        } @else {
            <button class="nav-btn" disabled>
                {{ "Next" | translate }}
                <span class="material-symbols-outlined">arrow_forward</span>
            </button>
        }
    </div>
    }


    <p-splitter [panelSizes]="device === 'mobile' ? [50, 50] : panelSizes"
        [minSizes]="device === 'mobile' ? [30, 30] : panelSizes"
        [layout]="device === 'mobile' ? 'vertical' : 'horizontal'" style="height: 100%;">

        <ng-template #panel>
            @if(device === 'mobile') {
            @if(activeTab === 'signing') {
            @if(showSignatureView) {
            <ng-container *ngTemplateOutlet="shareInfoTemplate"></ng-container>
            }
            @if(showSignatureView && !userSigned && type === 'Sign') {
            <ng-container *ngTemplateOutlet="signaturePadTemplate"></ng-container>
            } @else if(showSignatureView && userSigned && type === 'Sign') {
            <div class="signature-view">
                <ng-container *ngTemplateOutlet="alreadySignedTemplate"></ng-container>
            </div>
            }
            @else {
            @if(currentFileIndex === 0){
            <ng-container *ngTemplateOutlet="shareInfoTemplate"></ng-container>

            }
            <ng-container *ngTemplateOutlet="pdfViewerTemplate"></ng-container>
            }
            } @else if(activeTab === 'accesses') {
            <ng-container *ngTemplateOutlet="accessesListTemplate"></ng-container>
            }

            @if(!areButtonsEnabled() && !userSigned && activeTab === 'signing' && type === 'Sign' && !isSubmitting){
            <ng-container *ngTemplateOutlet="viewMessageTemplate"></ng-container>
            }

            <div class="bottom-mobile">
                <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
                @if(status != null){
                <ng-container *ngTemplateOutlet="tabsTemplate; context: {isMobile: true}"></ng-container>
                }
            </div>

            } @else {
            <div class="left-panel">
                <div class="left-content">
                    <div class="top-half">
                        <div class="tabs-status">
                            @if(status != null){
                            <ng-container *ngTemplateOutlet="tabsTemplate; context: {isMobile: false}"></ng-container>
                            }
                            <ng-container *ngTemplateOutlet="shareInfoTemplate"></ng-container>
                        </div>

                        @if(activeTab === 'signing') {
                        <div class="tabs-container">
                            <p-tabs value="0" orientation="vertical">
                                <p-tablist>
                                    @for (file of files; track file.fileId; let i = $index) {
                                    <p-tab [value]="i.toString()" (click)="onFileSelected(file)">
                                        <div class="tab-header"
                                            [ngClass]="{'tab-header-selected': selectedFileKey === (file.fileId || file.id)}">
                                            @if (isFileLoading(file)) {
                                            <i class="pi pi-spin pi-spinner"></i>
                                            } @else {
                                            <i class="pi pi-file-pdf"></i>
                                            }
                                            <div class="file-info-container">
                                                <span class="file-name" [pTooltip]="file.name" tooltipPosition="top">{{
                                                    file.name }}</span>
                                                <small class="file-size">{{ formatFileSize(file.size) }}</small>
                                            </div>
                                            @if (isGoogleFile(file)) {
                                            <a href="#" class="download-icon"
                                                (click)="downloadGoogleFile(file); $event.preventDefault(); $event.stopPropagation()">
                                                @if (isDownloading(file)) {
                                                <i class="pi pi-spin pi-spinner"></i>
                                                } @else {
                                                <i class="pi pi-download"></i>
                                                }
                                            </a>
                                            } @else {
                                            <a [href]="file.webContentLink" target="_blank" class="download-icon"
                                                (click)="$event.stopPropagation()">
                                                <i class="pi pi-download"></i>
                                            </a>
                                            }
                                            @if (isOwner && canDeleteFiles()) {
                                            <button class="delete-icon"
                                                (click)="deleteElement(file, 'file'); $event.stopPropagation()">
                                                <i class="pi pi-trash"></i>
                                            </button>
                                            }
                                        </div>
                                    </p-tab>
                                    }
                                </p-tablist>
                            </p-tabs>
                        </div>
                        }
                    </div>
                    <div class="bottom-half">
                        @if(!areButtonsEnabled() && !userSigned && type === 'Sign' && enabled && !isSubmitting){
                        <ng-container *ngTemplateOutlet="viewMessageTemplate"></ng-container>
                        }


                        @if(activeTab === 'signing' && !userSigned && type === 'Sign' && enabled && !isOwner) {
                        <div class="signature-section">
                            @if(showSignaturePad){
                            <div class="signature-header">{{ "Signature" | translate }}</div>
                            <div class="signature-pad-wrapper">
                                <ngx-signature-pad #signaturePad class="signaturePad" [options]="options"
                                    (onEnd)="onSignatureChange()">
                                </ngx-signature-pad>
                            </div>
                            }
                            <ng-container *ngTemplateOutlet="signatureActionsTemplate"></ng-container>
                        </div>
                        }

                        @if(activeTab === 'signing' && userSigned && type === 'Sign') {
                        <ng-container *ngTemplateOutlet="alreadySignedTemplate"></ng-container>
                        }

                        <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
                    </div>
                </div>
            </div>
            }
        </ng-template>

        <ng-template #panel>
            @if(activeTab === 'signing' && device !== 'mobile') {
            <ng-container *ngTemplateOutlet="pdfViewerTemplate"></ng-container>
            } @else if(activeTab === 'accesses' && device !== 'mobile') {
            <ng-container *ngTemplateOutlet="accessesListTemplate"></ng-container>
            }
        </ng-template>
    </p-splitter>
</div>